export default __webpack_public_path__ + "static/media/lab-test.daac00de.svg";